import { serophinContactUrl } from "@serophin/shared";

export const NotFoundPage = () => (
  <div class="rounded-2xl text-gray-900 dark:text-gray-100">
    <div class="px-6 py-4 flex items-center justify-center">
      <div class="text-center max-w-2xl">
        <h1 class="text-2xl md:text-4xl font-semibold mb-4 text-gray-800 dark:text-gray-200">Page Not Found</h1>

        <p class="text-lg md:text-xl text-gray-600 dark:text-gray-400 mb-4 leading-relaxed">
          Looks like you've wandered off the path. The page you're looking for doesn't exist or has been moved.
        </p>

        <div class="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <a href="/" class="px-6 py-3 bg-indigo-500 hover:bg-indigo-600 text-white font-medium rounded-lg transition-colors shadow-sm">
            Back to Home
          </a>
          <a
            href="/articles"
            class="px-6 py-3 bg-neutral-200 dark:bg-neutral-700 hover:bg-neutral-300 dark:hover:bg-neutral-700 text-gray-900 dark:text-gray-100 font-medium rounded-lg transition-colors"
          >
            Explore Articles
          </a>
        </div>

        <div class="mt-12 pt-8 border-t border-gray-200 dark:border-gray-700">
          <p class="text-sm text-gray-600 dark:text-gray-400">
            Need help?{" "}
            <a href={serophinContactUrl("nottldr")} class="text-indigo-500 hover:text-indigo-600 underline">
              Contact us
            </a>{" "}
            or check out our{" "}
            <a href="/faq" class="text-indigo-500 hover:text-indigo-600 underline">
              FAQ
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
);
